// Hooks that use the FieldEditorContext when available
import { useFieldEditorContext } from "./FieldEditorContext.tsx";

export function useFieldEditorData() {
  const { fieldEditorData, setFieldEditorData } = useFieldEditorContext();
  return { fieldEditorData, setFieldEditorData };
}

export function useDrillViewData() {
  const {
    drill,
    engine,
    view,
    DrillCanvas,
    performerPaintingProps,
    setPerformerPaintingProps,
    viewOptions,
    updateViewOptions,
    confirmShape,
    cancelShape,
    forceViewRecreate,
  } = useFieldEditorContext();

  return {
    drill,
    engine,
    view,
    DrillCanvas,
    performerPaintingProps,
    setPerformerPaintingProps,
    viewOptions,
    updateViewOptions,
    confirmShape,
    cancelShape,
    forceViewRecreate,
  };
}

export function usePlaybackData() {
  const {
    playbackState,
    setPlaybackState,
    handlePageChange,
    handleCountChange,
    handlePlayDrill,
    handleStopDrill,
  } = useFieldEditorContext();

  return {
    playbackState,
    setPlaybackState,
    handlePageChange,
    handleCountChange,
    handlePlayDrill,
    handleStopDrill,
  };
}

export function useCollaborationData() {
  const { collaborationReturn } = useFieldEditorContext();
  return collaborationReturn;
}

export function useDrillDocumentData() {
  const { drillDocumentData, updateDrillDocumentData } =
    useFieldEditorContext();
  return { drillDocumentData, updateDrillDocumentData };
}

export function useUserData() {
  const { userData } = useFieldEditorContext();
  return userData;
}

export function usePerformerManipulationData() {
  const {
    alignPerformersToLeft,
    alignPerformersToTop,
    alignPerformersHorizontally,
    alignPerformersToBottom,
    alignPerformersToCenter,
    alignPerformersToRight,
    handleNudgeRight,
    handleNudgeLeft,
    handleNudgeUp,
    handleNudgeDown,
    applyEvenSpacing,
    handleRotateClockwise,
    handleRotateCounterClockwise,
  } = useFieldEditorContext();

  return {
    alignPerformersToLeft,
    alignPerformersToTop,
    alignPerformersHorizontally,
    alignPerformersToBottom,
    alignPerformersToCenter,
    alignPerformersToRight,
    handleNudgeRight,
    handleNudgeLeft,
    handleNudgeUp,
    handleNudgeDown,
    applyEvenSpacing,
    handleRotateClockwise,
    handleRotateCounterClockwise,
  };
}

export function useKeyboardData() {
  const { handleKeyDown } = useFieldEditorContext();
  return { handleKeyDown };
}

export function useExportData() {
  const { exportEngine, exportCanvas } = useFieldEditorContext();
  return { exportEngine, exportCanvas };
}

export function usePageManagementData() {
  const { handleAddPageAtIndex, handleDeletePageAtIndex } =
    useFieldEditorContext();
  return { handleAddPageAtIndex, handleDeletePageAtIndex };
}

export function useLoadingData() {
  const { loading } = useFieldEditorContext();
  return { loading };
}
